import { render, staticRenderFns } from "./ItemBidding.vue?vue&type=template&id=316ea5e4&scoped=true"
import script from "./ItemBidding.vue?vue&type=script&lang=js"
export * from "./ItemBidding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ea5e4",
  null
  
)

export default component.exports